/**
 * Perception enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file Perception.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum Perception {
  SEEN_AND_HEARD           = 0,
  NOT_SEEN_AND_NOT_HEARD   = 1,
  HEARD_AND_NOT_SEEN       = 2,
  SEEN_AND_NOT_HEARD       = 3,
  NOT_HEARD                = 4,
  HEARD                    = 5,
  NOT_SEEN                 = 6,
  SEEN                     = 7,
}
  